import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Languages } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { uiLanguages } from "@/i18n";
import { cn } from "@/lib/utils";

/** variant="light" (default) suits white/light surfaces; "dark" suits the
 * mesh-hero/glass surfaces (auth pages) where a transparent trigger would
 * render illegible dark-on-dark text. */
export const LanguageSwitcher = ({ variant = "light" }) => {
  const { lang, switchLanguage } = useLanguage();

  return (
    <Select value={lang} onValueChange={switchLanguage}>
      <SelectTrigger
        className={cn(
          "w-[140px] rounded-sm",
          variant === "dark"
            ? "border-white/20 bg-white/10 text-white backdrop-blur-xl [&_svg]:text-white"
            : "border-slate-200"
        )}
        aria-label="Language"
        data-testid="language-switcher"
      >
        <Languages className="w-4 h-4 mr-2" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {uiLanguages.map(({ value, label }) => (
          <SelectItem key={value} value={value}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
